module.exports = __webpack_public_path__ + "static/media/img-app-interview-rescheduling@3x.808dfe01.png";